import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../../nodeInstance";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { useNavigate } from "react-router-dom";

export default function UpdatePopUp({
  list,
  PopUp,
  setPopUp,
  url,
  title,
  callBack,
}) {
  const navigate = useNavigate();

  var titles = [
    "SR NO.",
    "employee ID",
    "CLIENT",
    "VISA PROVIDER",
    "IQAMA NUMBER",
  ];
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);
  const [valueText, setInputValue] = React.useState(false);
  const { NoDataFound, currentList, PaginationIndex } = useSearchPagination(
    list ? list : []
  );

  var length = list.length;
  const handleInputChange = (event) => {
    setInputValue(event.target.value);
    console.log(event.target.value);
  };
  const token = localStorage.getItem("nodeToken");

  const update = async () => {

    setLoading(true);
    try {
      const response = await nodeinstance.post(url, {
        employee_id: list.map((data) => data.employee_id),
        fees: valueText,
        payment_status: "PENDING",
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 200) {
        dispatch(
          setAppError({
            msg: "Successfully uploaded.",
            color: "success",
          })
        );
        callBack();
        setPopUp(false);
      }
    } catch (error) {
      setLoading(false);
      dispatch(
        setAppError({
          msg: error?.response?.data.error,
        })
      );
    }
  };

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${PopUp ? "flex" : "hidden"
          }`}
      >
        <div
          className="max-w-3xl w-full  rounded-md bg-white/95 flex  flex-col p-5 relative"
          style={{ height: "500px" }}
        >
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>

          <div className="w-full flex flex-col gap-3 my-3 p-5">
            <div className="form-control w-full place-items-center">
              <h2 className="label place-items-center">{title}</h2>
            </div>
            <div className="flex flex-row">
              <h2 className=" place-items-center">TOTAL SELECT COUNT</h2>
              <h2 className=" place-items-center font-bold pl-5">{length}</h2>
            </div>
            <div className="flex flex-row place-items-center">
              <h2 className="place-items-center mr-2">Fees</h2>
              <input
                type="number"
                step={"0.01"}
                pattern="[0-9]*"
                min={10}
                className={`input input-sm h-10 max-w-xs w-full input-bordered focus:outline-none uppercase`}
                onChange={(e) => handleInputChange(e)}
                required
                width={4}
              />
              <button
                onClick={() => update()}
                className="p-2 ml-5 px-4 rounded-md bg-red disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
              >
                {" "}
                <p>Update</p>
                {loading ? <CgSpinner className="animate-spin" /> : ""}
              </button>
            </div>
          </div>
          <div
            className={`grid grid-cols-table-atm-pop auto-cols-min gap-5 p-6  w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
          >
            {titles.map((t, index) => (
              <p key={index} className="font-semibold uppercase">
                {t}
              </p>
            ))}
            {list?.isLoading && <LoadingWithLable className="col-span-6" />}
            {list?.isLoading && <LoadingWithLable className="col-span-6" />}
            {!list?.isLoading && <NoDataFound />}

            {!list?.isLoading
              ? currentList?.map((list, index) => (
                <React.Fragment key={index}>
                  <PaginationIndex index={index} />
                  <p>{list.employee_id || "-"}</p>
                  <p>{list.client || "-"}</p>
                  <p>{list.visa_provider || "-"}</p>
                  <p>{list.iqama_number || "-"}</p>
                  <hr
                    className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                  />
                </React.Fragment>
              ))
              : ""}
          </div>
        </div>
      </div>
    </>
  );
}
